import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../index.css";
import "./SelectionPageStyles.css"
import MediaCard from "../../components/MediaCard/MediaCard";
import CoverTitle from "../../components/CoverTitle/CoverTitle";
import MediaService from "../../services/mediaService";

function SelectionPage() {
    // Destructure the "username" parameter from the URL
  // const { classification } = useParams(); THIS WON'T WORK, TRY THE QUERYCLIENTt

  const navigate = useNavigate();
  const location = useLocation()
  const [mediaUrls, setMediaUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  
  let localClassification, type, category
  localClassification = location.pathname.slice(1)
  type = "video"

  let dynamicTitleStr

  switch(localClassification){
    case "portrait":
      category = "portrait-select-page"; dynamicTitleStr = "Portraits";
      break
    case "commercial":
      category = "commercial-select-page"; dynamicTitleStr = "Commercial"
      break
    case "cinematic":
      category = "cinematic-select-page"; dynamicTitleStr = "Cinematic";
      break
    default:
      category = "portrait-select-page"; dynamicTitleStr = "Selections";
  }


  useEffect(() => {
      // switch(classification){
      //   case "portrait":
      //   category = "portrait-select-page";
      //   break
      //   case "commercial":
      //   category = "commercial-select-page";
      //   break
      //   case "cinematic":
      //   category = "cinematic-select-page";
      //   break
      //   default:
      //   category = "404"
      // }
      
    async function fetchMedia() {
      try {
        // const response = await MediaService.getGallery(checkBlank(classification) && classification, checkBlank(type) && type, checkBlank(category) && category)
        const response = await MediaService.getGallery("assets", type, category)
        console.log("SelectionPage response ln 18: ", response)
        setMediaUrls(response.filter(file => file.id !== "" && file.size > 0).sort((a, b) => a.id.localeCompare(b.id)));
      } catch (error) {
        console.error("Error fetching R2 assets:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchMedia();
  }, []);

  const handleCategoryClick = (categoryName) => {
    console.log(`Navigating to /selection/${categoryName}`);
    navigate(`/selection/${categoryName}`);
  };
  
  if (loading) {
    return (
      <div className="selection-page-container" role="status" aria-live="polite">
        <p>Loading selections...</p>
      </div>
    );
  }

  if (mediaUrls.length < 2) {
    return (
      <div className="selection-page-container">
        <p>selection media is currently unavailable.</p>
      </div>
    );
  }

  return (
    <div className="selection-page-container">
        <CoverTitle clr="clr-dark-red"  class_Name="selection-page-title">{dynamicTitleStr}</CoverTitle>
              
      {/* Card 1: Image Background */}
     
      <div className="card-gallery-container">   
        <MediaCard
        // mediaSrc="/photo-assets/selections/selection-photo-reel-comp.mp4"
        mediaSrc={mediaUrls[0].src}
        mediaType="video"
        title="Photo"
        onClick={() => handleCategoryClick('photo')}
        class_Name="selection-media-card"
      />

      {/* Card 2: Video Background */}
      <MediaCard
        // mediaSrc="/video-assets/selections/models/mari-video-selection-comp.mp4"
        mediaSrc={mediaUrls[1].src}
        mediaType="video"
        title="Video"
        class_Name="selection-media-card"
        onClick={() => handleCategoryClick('video')}
      />
      </div>
   </div>
  );
}

export default SelectionPage;
